export enum EntityType {
  UNDEFINED = "UNDEFINED",
  MODELS = "MODELS",
  CORPORA = "CORPORA",
  DICTIONARY = "DICTIONARY",
  RECOMMENDATION = "RECOMMENDATION",
}
